const RTL_LANGUAGES = new Set(['he', 'ar', 'fa', 'ur', 'yi', 'ps', 'dv']);

export function isRtl(lang: string | null | undefined): boolean {
  if (!lang) return false;
  const base = lang.toLowerCase().split(/[-_]/, 1)[0];
  return RTL_LANGUAGES.has(base);
}
